import React from 'react'

export default function Padding() {
  return (
    <>
      <h1>Padding</h1>
      <p>There are several classes to quickly and easily apply padding styles to elements. </p>
    
      <h2>Complete Paddings</h2>
      <p>These apply paddings to all sides of the element: top, right, bottom and left</p>
      <h3>Code:</h3>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
            &lt;p class="bc-blue p-0"&gt;p-0&lt;/p&gt;<br />
            &lt;p class="bc-blue p-1"&gt;p-1&lt;/p&gt;<br />
            &lt;p class="bc-blue p-2"&gt;p-2&lt;/p&gt;<br />
            &lt;p class="bc-blue p-3"&gt;p-3&lt;/p&gt;<br />
            &lt;p class="bc-blue p-4"&gt;p-4&lt;/p&gt;<br />
          </p>
      </div>

      <h3>Result:</h3>
      <div className='border-grey p-1 border-curve'>
        <p className="bc-blue p-0">p-0</p>
        <p className="bc-blue p-1">p-1</p>
        <p className="bc-blue p-2">p-2</p>
        <p className="bc-blue p-3">p-3</p>
        <p className="bc-blue p-4">p-4</p>

      </div>

      <h2 className='mt-3'>Padding X-axis</h2>
      <p>These apply paddings to both the left and right side</p>
      <h3>Code:</h3>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
            &lt;p class="bc-blue px-0"&gt;px-0&lt;/p&gt;<br />
            &lt;p class="bc-blue px-1"&gt;px-1&lt;/p&gt;<br />
            &lt;p class="bc-blue px-2"&gt;px-2&lt;/p&gt;<br />
            &lt;p class="bc-blue px-3"&gt;px-3&lt;/p&gt;<br />
            &lt;p class="bc-blue px-4"&gt;px-4&lt;/p&gt;<br />
          </p>
      </div>

      <h3>Result:</h3>
      <div className='border-grey p-1 border-curve'>
        <p className="bc-blue px-0">px-0</p>
        <p className="bc-blue px-1">px-1</p>
        <p className="bc-blue px-2">px-2</p>
        <p className="bc-blue px-3">px-3</p>
        <p className="bc-blue px-4">px-4</p>
      </div>

      <h2 className='mt-3'>Padding Y-axis</h2>
      <p>These apply paddings to both the top and bottom side</p>
      <h3>Code:</h3>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
            &lt;p class="bc-blue py-0"&gt;py-0&lt;/p&gt;<br />
            &lt;p class="bc-blue py-1"&gt;py-1&lt;/p&gt;<br />
            &lt;p class="bc-blue py-2"&gt;py-2&lt;/p&gt;<br />
            &lt;p class="bc-blue py-3"&gt;py-3&lt;/p&gt;<br />
            &lt;p class="bc-blue py-4"&gt;py-4&lt;/p&gt;<br />
          </p>
      </div>

      <h3>Result:</h3>
      <div className='border-grey p-1 border-curve'>
        <p className="bc-blue py-0">py-0</p>
        <p className="bc-blue py-1">py-1</p>
        <p className="bc-blue py-2">py-2</p>
        <p className="bc-blue py-3">py-3</p>
        <p className="bc-blue py-4">py-4</p>
      </div>

      <h2 className='mt-3'>Padding Left </h2>
      <p><span className='tag-grey bold'>.pl-(number 0-4)</span> class applys paddings to the left side</p>
      <h3>Code:</h3>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
            &lt;p class="bc-blue pl-0"&gt;pl-0&lt;/p&gt;<br />
            &lt;p class="bc-blue pl-1"&gt;pl-1&lt;/p&gt;<br />
            &lt;p class="bc-blue pl-2"&gt;pl-2&lt;/p&gt;<br />
            &lt;p class="bc-blue pl-3"&gt;pl-3&lt;/p&gt;<br />
            &lt;p class="bc-blue pl-4"&gt;pl-4&lt;/p&gt;<br />
          </p>
      </div>

      <h3>Result:</h3>
      <div className='border-grey p-1 border-curve'>
        <p className="bc-blue pl-0">pl-0</p>
        <p className="bc-blue pl-1">pl-1</p>
        <p className="bc-blue pl-2">pl-2</p>
        <p className="bc-blue pl-3">pl-3</p>
        <p className="bc-blue pl-4">pl-4</p>
      </div>

      <h2 className='mt-3'> Padding Right</h2>
      <p><span className='tag-grey bold'>.pr-(number 0-4)</span> class applys paddings to the right side</p>
      <h3>Code:</h3>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
            &lt;span class="bc-blue pr-0"&gt;pr-0&lt;/span&gt;<br />
            &lt;span class="bc-blue pr-1"&gt;pr-1&lt;/span&gt;<br />
            &lt;span class="bc-blue pr-2"&gt;pr-2&lt;/span&gt;<br />
            &lt;span class="bc-blue pr-3"&gt;pr-3&lt;/span&gt;<br />
            &lt;span class="bc-blue pr-4"&gt;pr-4&lt;/span&gt;<br />
          </p>
      </div>

      <h3>Result:</h3>
      <div className='border-grey m-items-1 p-1 border-curve'>
        <span className="bc-blue pr-0">pr-0</span>
        <span className="bc-blue pr-1">pr-1</span>
        <span className="bc-blue pr-2">pr-2</span>
        <span className="bc-blue pr-3">pr-3</span>
        <span className="bc-blue pr-4">pr-4</span>
      </div>

      <h2>Padding Top & Padding Bottom</h2>
      <p><span className='tag-grey bold'>.pt-(number 0-4)</span> class applys paddings to the top side</p>
      <p><span className='tag-grey bold'>.pb-(number 0-4)</span> class applys paddings to the bottom side</p>      <h3>Code:</h3>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
            &lt;p class="bc-blue pt-0"&gt;pt-0&lt;/p&gt;<br />
            &lt;p class="bc-blue pt-1"&gt;pt-1&lt;/p&gt;<br />
            &lt;p class="bc-blue pt-2"&gt;pt-2&lt;/p&gt;<br />
            &lt;p class="bc-blue pt-3"&gt;pt-3&lt;/p&gt;<br />
            &lt;p class="bc-blue pt-4"&gt;pt-4&lt;/p&gt;<br />
            &lt;p class="bc-blue pb-0"&gt;pb-0&lt;/p&gt;<br />
            &lt;p class="bc-blue pb-1"&gt;pb-1&lt;/p&gt;<br />
            &lt;p class="bc-blue pb-2"&gt;pb-2&lt;/p&gt;<br />
            &lt;p class="bc-blue pb-3"&gt;pb-3&lt;/p&gt;<br />
            &lt;p class="bc-blue pb-4"&gt;pb-4&lt;/p&gt;<br />
          </p>
      </div>

      <h3>Result:</h3>
      <div className='border-grey p-1 border-curve'>
        <p className="bc-blue pt-0">pt-0</p>
        <p className="bc-blue pt-1">pt-1</p>
        <p className="bc-blue pt-2">pt-2</p>
        <p className="bc-blue pt-3">pt-3</p>
        <p className="bc-blue pt-4">pt-4</p>
        <p className="bc-blue pb-0">pb-0</p>
        <p className="bc-blue pb-1">pb-1</p>
        <p className="bc-blue pb-2">pb-2</p>
        <p className="bc-blue pb-3">pb-3</p>
        <p className="bc-blue pb-4">pb-4</p>
      </div>

      <h2 className='mt-3'>Padding Items Classes</h2>
      <p> These classes add a set padding to all the child elements of this class</p>
      <ul className='mb-items-1'>
        <li><span className='tag-grey bold'>.p-items-(number 0-4)</span> class applys paddings to the all sides of all child elements</li>
        <li><span className='tag-grey bold'>.pt-items-(number 0-4)</span> class applys paddings to the top side of all child element</li>
        <li><span className='tag-grey bold'>.pb-items-(number 0-4)</span> class applys paddings to the bottom side of all child element</li>
        <li><span className='tag-grey bold'>.pl-items-(number 0-4)</span> class applys paddings to the left side of all child element</li>
        <li><span className='tag-grey bold'>.pr-items-(number 0-4)</span> class applys paddings to the right side of all child element</li>
        <li><span className='tag-grey bold'>.px-items-(number 0-4)</span> class applys paddings to the left annd right side of all child element</li>
        <li><span className='tag-grey bold'>.py-items-(number 0-4)</span> class applys paddings to the top and bottom side of all child element</li>
      </ul>
    </>
    )
}
